module.exports = __webpack_public_path__ + "files/39ab55da86e9ca536e74eda3d98de9a3.png";